// extracted by mini-css-extract-plugin
module.exports = {"totalValues":"styles_totalValues__2TsgR"};